module.exports = __webpack_public_path__ + "static/media/icon_yanglao.a72f8f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_yanglao.png
// module id = 2167
// module chunks = 0